import { type IssueTypePriority } from "@overmap-ai/common"
import { selectIssueTypePriorityById } from "@overmap-ai/core"
import { cx } from "class-variance-authority"
import { memo } from "react"

import { issuePriorityTypeData } from "../../mappings/issues"
import { useAppSelector } from "../../store"
import { DEFAULT_MAX_ICONS } from "./constants"
import { LuIconWithWrapper, type LuIconWithWrapperProps } from "./LuIconWithWrapper"
import type { IconsProps } from "./typings"

interface IssuePriorityIconProps extends Omit<LuIconWithWrapperProps, "color" | "icon"> {
	priority: IssueTypePriority["uuid"]
}

export const IssuePriorityIcon = memo<IssuePriorityIconProps>((props) => {
	const { ref, priority, ...rest } = props

	const issueTypePriority = useAppSelector(selectIssueTypePriorityById(priority))!
	const { icon } = issuePriorityTypeData[issueTypePriority.type]

	return <LuIconWithWrapper ref={ref} color={issueTypePriority.color} icon={icon} {...rest} />
})
IssuePriorityIcon.displayName = "IssuePriorityIcon"

interface IssuePriorityIconsProps extends IconsProps {
	priorities: IssueTypePriority["uuid"][]
}

export const IssuePriorityIcons = memo<IssuePriorityIconsProps>((props) => {
	const { ref, className, priorities, max = DEFAULT_MAX_ICONS, ...rest } = props

	return (
		<span ref={ref} className={cx("flex -space-x-2", className)} {...rest}>
			{priorities.slice(0, max ?? priorities.length).map((priority, index) => (
				<IssuePriorityIcon priority={priority} key={`${priority}-${index}`} background />
			))}
		</span>
	)
})
IssuePriorityIcons.displayName = "IssuePriorityIcons"
